import CONFIG from '../Services/CONFIG';
import { Auth0AppProvider } from './Auth0AppProvider';
import { KeycloakAuthProvider } from './KeycloakAuthProvider';

export const AuthProvider = ({ children }) => {
  switch (CONFIG.AUTH_PROVIDER) {
    case 'keycloak':
      return <KeycloakAuthProvider>{children}</KeycloakAuthProvider>;

    case 'auth0':
      return <Auth0AppProvider>{children}</Auth0AppProvider>;

    default:
      return children;
  }
};
